module.exports = __webpack_public_path__ + "img/album13_11.b68cf66f.jpg";